module.exports = __webpack_public_path__ + "5061df1fe74571793bd62ac16aae539f.png";